import { z } from "zod";
export const stripeWebhookEventSchema = z.object({
    type: z.string(),
    data: z.object({
        object: z.object({
            id: z.string(),
            metadata: z.object({
                booking_id: z.string(),
                payment_type: z.string(),
                owner_id: z.string(),
            }),
        }),
    }),
});
const swiklyFreeTextMetadataSchema = z.object({
    owner_id: z.string(),
    caution_id: z.string().optional(),
    booking_id: z.string().optional(),
    kind: z.enum(["caution", "booking_security"]).optional(),
});
export const swiklyWebhookEventSchema = z.object({
    event: z.enum(["requestSecured", "allPendingReclaimsCompleted", "allPendingRefundsCompleted"]),
    request: z.object({
        id: z.string(),
        accountId: z.string(),
        customId: z.string().nullish(),
        freeText: z.string().nullish(),
        deposit: z
            .object({
            id: z.string(),
            status: z.string(),
            securedAmount: z.number().nullish(),
            amount: z.number(),
        })
            .nullish(),
    }),
});
export const parseSwiklyFreeText = (raw) => {
    if (!raw)
        return null;
    try {
        const parsed = JSON.parse(raw);
        const result = swiklyFreeTextMetadataSchema.safeParse(parsed);
        return result.success ? result.data : null;
    }
    catch {
        return null;
    }
};
